import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialog-delete-item',
  templateUrl: './dialog-delete-item.component.html',
  styleUrls: ['./dialog-delete-item.component.css']
})
export class DialogDeleteItemComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
